// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__104Rd","column":"style_column__1QkDE","row":"style_row__Kxy0j"};